import { bindRequestLogic } from './utils'
import DashboardTypes from '../actionTypes/dashboard'
import { dashboardAPI } from '../api'

const getRealtimeMetrics = bindRequestLogic({
  clientFunc: dashboardAPI.getRealtimeMetrics,
  type: DashboardTypes.GET_REAL_TIME_METRICS_REQUEST,
  successType: DashboardTypes.GET_REAL_TIME_METRICS_SUCCESS,
  failType: DashboardTypes.GET_REAL_TIME_METRICS_FAILED,
  isQueryParam: true
})

const getMonthlyTripStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyTripStatistics,
  type: DashboardTypes.GET_MONTHLY_TRIP_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_TRIP_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_TRIP_STATISTICS_FAILED
})

const getMonthlyDigitalKeyStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyDigitalKeyStatistics,
  type: DashboardTypes.GET_MONTHLY_DIGITAL_KEY_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_DIGITAL_KEY_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_DIGITAL_KEY_STATISTICS_FAILED
})

const getMonthlyRiderStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyRiderStatistics,
  type: DashboardTypes.GET_MONTHLY_RIDER_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_RIDER_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_RIDER_STATISTICS_FAILED
})

const getMonthlyRiderSubscriptionsStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyRiderSubscriptionsStatistics,
  type: DashboardTypes.GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_REQUEST,
  successType:
    DashboardTypes.GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_FAILED
})

const getMonthlyAlertStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyAlertStatistics,
  type: DashboardTypes.GET_MONTHLY_ALERT_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_ALERT_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_ALERT_STATISTICS_FAILED
})

const getMonthlyPersActivityStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyPersActivityStatistics,
  type: DashboardTypes.GET_MONTHLY_PERS_ACTIVITY_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_PERS_ACTIVITY_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_PERS_ACTIVITY_STATISTICS_FAILED
})

const getMonthlyDirectVehicleStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyDirectVehicleStatistics,
  type: DashboardTypes.GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_FAILED
})

const getMonthlyRiderPermanentSharingsStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyRiderPermanentSharingsStatistics,
  type: DashboardTypes.GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_REQUEST,
  successType:
    DashboardTypes.GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_SUCCESS,
  failType:
    DashboardTypes.GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_FAILED
})

const getMonthlyRiderTemporarySharingsStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyRiderTemporarySharingsStatistics,
  type: DashboardTypes.GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_REQUEST,
  successType:
    DashboardTypes.GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_SUCCESS,
  failType:
    DashboardTypes.GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_FAILED
})

const getMonthlyCompanyStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyCompanyStatistics,
  type: DashboardTypes.GET_MONTHLY_COMPANY_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_COMPANY_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_COMPANY_STATISTICS_FAILED
})

const getCurrentDataCompanyStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getCurrentDataCompanyStatistics,
  type: DashboardTypes.GET_CURRENT_DATA_COMPANY_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_CURRENT_DATA_COMPANY_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_CURRENT_DATA_COMPANY_STATISTICS_FAILED
})

const getCurrentRidersStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getCurrentRidersStatistics,
  type: DashboardTypes.GET_CURRENT_RIDERS_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_CURRENT_RIDERS_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_CURRENT_RIDERS_STATISTICS_FAILED
})

const getRidersDashboardStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getRidersDashboardStatistics,
  type: DashboardTypes.GET_RIDERS_DASHBOARD_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_RIDERS_DASHBOARD_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_RIDERS_DASHBOARD_STATISTICS_FAILED
})

const getMonthlyManufacturerPersReceptionStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyManufacturerPersReceptionStatistics,
  type: DashboardTypes.GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_REQUEST,
  successType:
    DashboardTypes.GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_SUCCESS,
  failType:
    DashboardTypes.GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_FAILED
})

const getMonthlySubcontractorPersReceptionStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlySubcontractorPersReceptionStatistics,
  type: DashboardTypes.GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_REQUEST,
  successType:
    DashboardTypes.GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_SUCCESS,
  failType:
    DashboardTypes.GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_FAILED
})

const getMonthlyProducedVehiclesStatistics = bindRequestLogic({
  clientFunc: dashboardAPI.getMonthlyProducedVehiclesStatistics,
  type: DashboardTypes.GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_REQUEST,
  successType: DashboardTypes.GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_SUCCESS,
  failType: DashboardTypes.GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_FAILED
})

const getDetailRealtimeAlerts = bindRequestLogic({
  clientFunc: dashboardAPI.getDetailRealtimeAlerts,
  type: DashboardTypes.GET_DETAIL_REALTIME_ALERTS_REQUEST,
  successType: DashboardTypes.GET_DETAIL_REALTIME_ALERTS_SUCCESS,
  failType: DashboardTypes.GET_DETAIL_REALTIME_ALERTS_FAILED
})

export default [
  getRealtimeMetrics,
  getMonthlyTripStatistics,
  getMonthlyDigitalKeyStatistics,
  getMonthlyRiderStatistics,
  getMonthlyRiderSubscriptionsStatistics,
  getMonthlyAlertStatistics,
  getMonthlyPersActivityStatistics,
  getMonthlyDirectVehicleStatistics,
  getMonthlyRiderPermanentSharingsStatistics,
  getMonthlyRiderTemporarySharingsStatistics,
  getMonthlyCompanyStatistics,
  getCurrentDataCompanyStatistics,
  getCurrentRidersStatistics,
  getRidersDashboardStatistics,
  getMonthlyManufacturerPersReceptionStatistics,
  getMonthlySubcontractorPersReceptionStatistics,
  getMonthlyProducedVehiclesStatistics,
  getDetailRealtimeAlerts
]
